import { lazy } from 'react'
import { FileText, Radar } from 'lucide-react'
import type { FeatureRoute, NavItem } from '@/features/types'

const Rfps = lazy(() => import('@/features/rfp/pages/Rfps').then((m) => ({ default: m.Rfps })))
const RfpDetail = lazy(() => import('@/features/rfp/pages/RfpDetail').then((m) => ({ default: m.RfpDetail })))
const RfpResponse = lazy(() => import('@/features/rfp/pages/RfpResponse').then((m) => ({ default: m.RfpResponse })))
const Foia = lazy(() => import('@/features/rfp/pages/Foia').then((m) => ({ default: m.Foia })))
const RfpSourcing = lazy(() => import('@/features/rfp/pages/RfpSourcing').then((m) => ({ default: m.RfpSourcing })))

export const rfpRoutes: FeatureRoute[] = [
  { path: 'rfps', element: <Rfps /> },
  { path: 'rfps/:id', element: <RfpDetail /> },
  { path: 'rfps/:id/response', element: <RfpResponse /> },
  { path: 'foia', element: <Foia /> },
  // Feed-sourced RFP candidates awaiting triage (#wYsFbjHM). Its own path rather
  // than a tab on /rfps: candidates are not tracked RFPs, and 99% of a feed never
  // becomes one.
  { path: 'rfp-sourcing', element: <RfpSourcing /> },
]

export const rfpNav: NavItem[] = [
  { to: '/rfps', label: 'RFP tracker', icon: FileText, section: 'Sales' },
  { to: '/rfp-sourcing', label: 'RFP sourcing', icon: Radar, section: 'Sales' },
]
